export default {
  dbl_personal_data_title: 'Personal Data',
  dbl_personal_data_enter_analysis: 'Enter Analysis',
  dbl_personal_data_search: 'Search by name or description',
  dbl_personal_data_table_name: 'Table',
  dbl_personal_data_name: 'Table',
  dbl_personal_data_description: 'Description',
  dbl_personal_data_creation_time: 'Create Time',
  dbl_personal_data_operation: 'Actions',
  dbl_personal_data_analysis: 'Analysis',
  dbl_personal_data_details: 'Details',
  dbl_personal_data_database: 'Database',
  dbl_personal_data_size: 'Size',
  dbl_personal_data_table_structure: 'Table Structure',
  dbl_personal_data_data_preview: 'Data Preview',
  dbl_personal_data_columns: 'columns',
  dbl_personal_data_column_name: 'Column Name',
  dbl_personal_data_display_name: 'Display Name',
  dbl_personal_data_field_name: 'Field Name',
  dbl_personal_data_field_type: 'Field Type',
  dbl_personal_data_column_type: 'Data Type',
  dbl_personal_data_column_comment: 'Description',
  dbl_personal_data_metric_dimension: 'Dimension/Metric',
  dbl_personal_data_dimension_value_settings: 'Dimension Value Settings',
  dbl_personal_data_include_dimension_total_value: 'Include Dimension Total Value',
  dbl_personal_data_field_desc: 'Field Description',
  dbl_personal_data_metric: 'Metric',
  dbl_personal_data_dimension: 'Dimension',
  dbl_personal_data_origin: 'Original Dimension Value',
  dbl_personal_data_system: 'System Auto Match',
  dbl_personal_data_include: 'Include',
  dbl_personal_data_exclude: 'Exclude',
  dbl_personal_data_not_show: 'Not Show',
  dbl_personal_data_column_nullable: 'Nullable',
  dbl_personal_data_column_default: 'Default Value',
  dbl_personal_data_total: 'Total {total} Items',
  dbl_personal_data_select_limit_tip: 'Select up to 3, please cancel and then select',
  dbl_data_table_size: 'Table size',

  // Validation error messages
  dbl_personal_data_name_empty: 'Cannot be empty',
  dbl_personal_data_name_too_long: 'Length limit of 200 characters',
  dbl_personal_data_name_invalid_format: 'Start with a letter, only letters, numbers, and underscores allowed. Special characters must be quoted or escaped',
  dbl_personal_data_duplicate_name: 'Copied',
  
  dbl_personal_data_upload_data: 'Upload Data',
  dbl_personal_data_search_sheets: 'Search Sheets',
  dbl_personal_data_choose_delimiter: 'Choose Delimiter',
  dbl_personal_data_comma: '","(Comma)',
  dbl_personal_data_semicolon: '";"(Semicolon)',
  dbl_personal_data_colon: '":"(Colon)',
  dbl_personal_data_equal: '"="(Equal)',
  dbl_personal_data_space: 'Space',
  dbl_personal_data_re_upload: 'Re-upload',
  dbl_personal_data_enter_table_name: 'Please Enter Table Name',
  dbl_personal_data_enter_table_description: 'Please Enter Table Description',
  dbl_personal_data_table_information: 'Table Information',
  dbl_personal_data_support_format: 'Support Excel(.xlsx), CSV and TXT format',
  dbl_personal_data_sheets_selection: 'Sheets Selection',
  dbl_personal_data_upload_date: 'Upload Date',
  dbl_personal_data_file_size: 'File Size',
  dbl_personal_data_table_name_empty: 'Table name can\'t be empty',
  dbl_personal_data_no_item_selected: 'No Item Selected For Preview',
  dbl_personal_data_click_to_upload: 'Click to upload',
  dbl_personal_data_drag_to_area: 'Drag to this Area',
  dbl_personal_data_next_step: 'Next Step',
  dbl_personal_data_prev_step: 'Prev Step',
  dbl_personal_data_submit: 'Submit',
  dbl_personal_data_name_label: 'Name',
  dbl_personal_data_description_label: 'Description',
  dbl_personal_data_no_sheets_selected: 'No sheets selected, please go back to the previous step to select sheets',
  dbl_personal_data_file_exceeds_limit: 'File exceeds limit',
  dbl_personal_data_file_exceeds_500mb: 'File exceeds 500 MB limit',
  dbl_personal_data_file_exceeds_100mb: 'File exceeds 100 MB limit',
  dbl_personal_data_cancel_upload: 'Cancel',
  dbl_personal_data_delete: 'Delete',
  dbl_personal_data_delete_title: 'Delete File？',
  dbl_personal_data_delete_content: 'Deletion is irreversible, please proceed with caution.',
  dbl_personal_data_release_mouse: 'Release mouse',
  dbl_personal_data_upload: 'Upload',
  dbl_personal_data_select_sheets: 'Please Select the sheets on the left',
  dbl_personal_data_close_title: 'Close the current upload task?',
  dbl_personal_data_close_content: 'The upload task has not been saved. Closing will result in the loss of all content.',
  dbl_personal_data_sheet_empty: 'No data in this sheet',
  dbl_personal_data_file_empty: 'Cannot upload an empty file. Please check and select a valid file to upload.',
  dbl_personal_data_wrong_file_type: 'Wrong File Type',
  dbl_personal_data_save_success: 'Data uploaded successfully',
  dbl_personal_data_upload_success: 'Uploaded successfully!',
  dbl_personal_data_upload_fail: 'Upload failed!',

  // common reuse keys for autotip
  dbl_common_loading: 'Loading...',
  dbl_common_load_fail: 'Load failed',
  dbl_common_not_search: 'No results found',
  dbl_common_go_back_old: 'Back to list',
};


